<template>
    <div class="blog_categories">
        <div class="row">
            <div class="col-md-12">
                <button class="btn btn-success pull-right" @click="goCreate"><i class="fa fa-plus"></i> Yeni Kategori Ekle</button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Başlık</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.title }}</td>
                                        <td>
                                            <router-link :to="{ name: 'blog_categories.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs"> Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                tableName: 'Blog Kategori Tablosu',
                icon: 'fa fa-rss',
                tableDesc: '',
                api: 'blog_categories',
                items: [],
                search: '',
            }
        },
        mounted () {
            this.getData()
        },
        methods: {
            getData() {
                this.$Progress.start()
                this.axios.get(this.api)
                    .then(response => {
                        this.items = response.data
                        this.$Progress.finish()
                    })
            },
            goCreate() {
                this.$router.push({ name: 'blog_categories.create' })
            }
        },
    }
</script>

<style scoped>

</style>